import React from 'react'

const Button = ({ imgSrc, onClick, style, text, }) => {
  return (
    <button className=""
      onClick={e=> onClick(e)}
      style={style}
    >
      <img className="" style={{ width: "100%", height: "100%" }} src={imgSrc} alt="loc" />
    </button>
  );
};

export default Button; { }